import './@types.js';

import { waitForProperty } from '@remento/web-utils/dom/initialization';

export async function waitForWisepopsLoaded(timeout: number | null = 2000): Promise<void> {
  // @ts-expect-error window.wisepops will only be defined once this function has executed
  if (window.wisepops) {
    return;
  }
  await waitForProperty(window, 'wisepops');
}
